import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { Sc4FailedMessagesListFacade } from './sc4-failed-messages-list.facade';

@Injectable({
  providedIn: 'root',
})
export class Sc4FailedMessagesListGuard {
  constructor(private sc4FailedMessagesListFacade: Sc4FailedMessagesListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.sc4FailedMessagesListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.sc4FailedMessagesListFacade);
  }
}
